import { render, staticRenderFns } from "./GroupDistributeMatrixPhone.vue?vue&type=template&id=45847999&scoped=true&"
import script from "./GroupDistributeMatrixPhone.vue?vue&type=script&lang=js&"
export * from "./GroupDistributeMatrixPhone.vue?vue&type=script&lang=js&"
import style0 from "./GroupDistributeMatrixPhone.vue?vue&type=style&index=0&id=45847999&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45847999",
  null
  
)

export default component.exports